export default __webpack_public_path__ + "static/media/doubleArrow.7cc0e759.svg";